import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center" }
const _hoisted_2 = { class: "bg-primary rounded-full p-2 mr-2" }
const _hoisted_3 = { class: "space-y-0" }
const _hoisted_4 = { class: "text-gray-500 uppercase text-sm" }
const _hoisted_5 = { class: "font-body text-xl text-gray-700" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponent()), { class: "w-6 h-6 text-white" }))
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.title), 1),
      _createVNode("p", _hoisted_5, "$" + _toDisplayString(_ctx.amount), 1)
    ])
  ]))
}